import { CONFIG_FIELD_TYPE } from './constant'
import i18n from '../i18n'

export const isChineseSite = () => {
  // 使用localhost或ohttps.com.cn访问时，显示中文站点
  // 使用127.0.0.1或ohttps.com访问时，显示国际站点
  return window.location.hostname.endsWith('localhost') || window.location.hostname.endsWith('ohttps.com.cn')
}

export const getCustomerServiceEmail = () => {
  return isChineseSite() ? 'service@ohttps.com.cn' : 'service@ohttps.com'
}

export const getCustomerServicePhone = () => {
  return ''
}

export const checkAccessJson = ({providerConfigJson, serverAccessJson}) => {
  serverAccessJson = Object.assign(providerConfigJson.default || {}, serverAccessJson)
  for (const {field, name, type, nullable, showWhen} of providerConfigJson.fields) {
    if (nullable) {
      continue
    }
    if (showWhen) {
      // $变量会在eval中使用
      // eslint-disable-next-line no-unused-vars
      const $ = serverAccessJson
      // eslint-disable-next-line no-eval
      const visible = eval(showWhen)
      if (!visible) {
        continue
      }
    }
    if (!serverAccessJson[field] || !serverAccessJson[field].trim()) {
      switch (type) {
        case CONFIG_FIELD_TYPE.SELECT:
          return i18n.t('configField.selectPlaceholder', {name})
        default:
          return i18n.t('configField.inputPlaceholder', {name})
      }
    }
  }
}

export const maskEmail = ({email}) => {
  // 邮箱脱敏：邮箱@之前部分1/2的内容使用*代替
  const emailParts = email.split('@')
  const maskedEmail = emailParts[0].slice(0, parseInt(emailParts[0].length / 4)) + 
                      '*'.repeat(emailParts[0].length - parseInt(emailParts[0].length / 2)) + 
                      emailParts[0].slice(emailParts[0].length - parseInt(emailParts[0].length / 2) + parseInt(emailParts[0].length / 4)) + 
                      '@' +
                      emailParts[1]
  return maskedEmail
}

export const getHttpProxyNginxConfig = ({ domains, userCode, proxyPath, proxyHost }) => {
  return `# ${i18n.t('httpProxyNginxConfig.title')}\n\n` + 
  domains.map(domain => {
    return `server {
    # ${i18n.t('httpProxyNginxConfig.listen')}
    listen  80;
    server_name  ${domain.toLowerCase().replace('*.', '')};

    location ${proxyPath} {
        # ${i18n.t('httpProxyNginxConfig.proxySetHeader')}
        proxy_set_header  x-ohttps-user  ${userCode};

        # ${i18n.t('httpProxyNginxConfig.proxyPass')}
        proxy_pass  ${proxyHost}${proxyPath};
    }

    # ${i18n.t('httpProxyNginxConfig.otherNginxConfig')}
}`
  }).join('\n\n')
}
